import Avatar1 from '@/assets/avatars/avatar_001.svg';
import Avatar2 from '@/assets/avatars/avatar_002.svg';
import Avatar3 from '@/assets/avatars/avatar_003.svg';
import Avatar4 from '@/assets/avatars/avatar_004.svg';
import Avatar5 from '@/assets/avatars/avatar_005.svg';
import Avatar6 from '@/assets/avatars/avatar_006.svg';
import Avatar7 from '@/assets/avatars/avatar_007.svg';
import Avatar8 from '@/assets/avatars/avatar_008.svg';
import Avatar9 from '@/assets/avatars/avatar_009.svg';
import Avatar10 from '@/assets/avatars/avatar_010.svg';
import Avatar11 from '@/assets/avatars/avatar_011.svg';
import Avatar12 from '@/assets/avatars/avatar_012.svg';
import Avatar13 from '@/assets/avatars/avatar_013.svg';
import Avatar14 from '@/assets/avatars/avatar_014.svg';
import Avatar15 from '@/assets/avatars/avatar_015.svg';

export const AVATARS = {
  avatar_001: Avatar1,
  avatar_002: Avatar2,
  avatar_003: Avatar3,
  avatar_004: Avatar4,
  avatar_005: Avatar5,
  avatar_006: Avatar6,
  avatar_007: Avatar7,
  avatar_008: Avatar8,
  avatar_009: Avatar9,
  avatar_010: Avatar10,
  avatar_011: Avatar11,
  avatar_012: Avatar12,
  avatar_013: Avatar13,
  avatar_014: Avatar14,
  avatar_015: Avatar15,
};
